import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";

const Logout = () => {
  const { instance } = useMsal();

  useEffect(() => {
    handleLogout();
  }, []);

  const handleLogout = () => {
    instance.logoutRedirect().catch((error) => {
      // Logout error handled silently
    });
  };

  return <>logout</>;
};

export default Logout;
